module.exports = __webpack_public_path__ + "images/help/avatars/leimeng-1bcbdd87df799bbc7c34f1f398f650c6.jpg";